<template>
    <multiselect
            v-model="feeTypes"
            :options="activeFeeTypes"
            track-by="uuid"
            label="name"
            :multiple="true"
            :allowEmpty="!!allowEmpty"
            placeholder="Tipo de Cuota"
            selectedLabel=""
            selectLabel=""
            deselectLabel=""
            @input="notifyChange"></multiselect>
</template>

<script>
    import Multiselect from 'vue-multiselect';
    import {mapGetters} from 'vuex';

    export default {
        name: "FeeTypeMultipleSelector",
        components: {
            Multiselect
        },
        props: {
            value: Array,
            allowEmpty: Boolean
        },
        data: function () {
            return {
                feeTypes: []
            }
        },
        computed: {
            ...mapGetters([
                'activeFeeTypes'
            ])
        },
        mounted() {
            this.$store.dispatch('loadFeeTypes');
            this.feeTypes = this.evaluateValue(this.value);
        },
        methods: {
            evaluateValue(uuids) {
                if (Array.isArray(uuids) && !!uuids.length) {
                    let array = [];
                    uuids.forEach((uuid) => {
                        if (!!uuid && !!this.findFeeTypeByUuid(uuid)) {
                            array.push(this.findFeeTypeByUuid(uuid));
                        }
                    });
                    return array;
                } else {
                    return [];
                }
            },

            findFeeTypeByUuid(uuid) {
                return this.activeFeeTypes.find(feeType => (feeType.uuid === uuid));
            },
            notifyChange(selected) {
                this.$emit('input', selected.map(feeType => feeType.uuid));
            }
        },
        watch: {
            value: function () {
                this.feeTypes = this.evaluateValue(this.value);
            }
        }
    }
</script>

<style scoped>

</style>
